<template>
  <div
    id="supplierEdit"
    v-loading="loading"
  >
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            {{ $route.query.supplierId ? '編輯社區廠商' : '新增廠商資訊' }}
          </div>
        </div>
        <div class="right">
          <span class="tips">*為必填</span>
        </div>
      </div>
      <div class="blockWrap">
        <el-form
          ref="newsData"
          class="list"
          :model="newsData"
          status-icon
          label-position="left"
          :rules="rule"
          :show-message="false"
        >
          <el-form-item
            label="廠商名稱"
            prop="Name"
          >
            <div class="flex-wrap">
              <el-input
                v-model="newsData.Name"
                placeholder="請輸入名稱"
                maxlength="20"
              />
              <div class="limit-note">
                限20個字元
              </div>
            </div>
          </el-form-item>
          <el-form-item
            label="簡述"
            prop="SubTitle"
          >
            <div class="flex-wrap">
              <el-input
                v-model="newsData.SubTitle"
                placeholder="請輸入該廠商資訊簡述說明"
                maxlength="45"
              />
              <div class="limit-note">
                限45個字元
              </div>
            </div>
          </el-form-item>
          <el-form-item
            label="類別"
            prop="Type"
          >
            <el-select
              v-model="newsData.Type"
              placeholder="請選擇"
            >
              <el-option
                v-for="item in typeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="統一編號"
            prop="UniformNum"
          >
            <el-input
              v-model="newsData.UniformNum"
              type="text"
              placeholder="請輸入統一編號"
              maxlength="10"
              @input="filterUniformNumInput"
            />
          </el-form-item>
          <el-form-item
            label="聯絡人"
            prop="contact"
          >
            <el-input
              v-model="newsData.ContactName"
              placeholder="請輸入聯絡人"
              maxlength="10"
              @input="filterContactInput"
            />
          </el-form-item>
          <div class="phone-wrap">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item
                  label="電話"
                  prop="Phone"
                >
                  <el-input
                    v-model="newsData.Phone"
                    placeholder="請輸入號碼(例：04-22974588)"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="手機"
                  prop="Cellphone"
                >
                  <el-input
                    v-model="newsData.Cellphone"
                    placeholder="請輸入號碼"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <el-form-item
            label="地址"
            prop="Address"
          >
            <el-row :gutter="10">
              <el-col :span="6">
                <el-select
                  v-model="newsData.City"
                  placeholder="請選擇城市"
                  @change="setAreaList"
                >
                  <el-option
                    v-for="item in cityList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-col>
              <el-col :span="6">
                <el-select
                  v-model="newsData.Area"
                  placeholder="請選擇區域"
                >
                  <el-option
                    v-for="item in areaList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-col>
              <el-col :span="12">
                <el-input
                  v-model="newsData.Address"
                  placeholder="請輸入地址"
                />
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item
            label="廠商介紹"
            prop="Content"
          >
            <el-input
              v-model="newsData.Content"
              type="textarea"
              maxlength="200"
            />
            <div class="content-limit">
              限200個字元
            </div>
          </el-form-item>
          <el-form-item
            label="附加檔案（名片/合約/報價單）"
            prop="Files"
          >
            <template>
              <file
                type="file"
                :filearray="newsData.Files"
                name="file"
                :quantity="5"
                @on-fileArray-change="FilesChange"
              />
            </template>
          </el-form-item>
        </el-form>
      </div>
      <div class="bottomControl">
        <el-button
          round
          @click="$router.back()"
        >
          取消
        </el-button>
        <el-button
          type="primary"
          :disabled="isDisable"
          round
          @click="SubNewsData"
        >
          送出
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import file from '@/components/File'
export default {
  components: {
    file
  },
  data () {
    return {
      newsData: {
        Name: '',
        SubTitle: '',
        Type: '',
        UniformNum: '',
        ContactName: '',
        Phone: '',
        Cellphone: '',
        City: '',
        Area: '',
        Address: '',
        Content: '',
        Files: []
      },
      originAttachments: [],
      deleteAttachments: [],
      rule: {
        Name: [
          { required: true, message: '', trigger: 'blur' }
        ],
        Type: [
          { required: true, message: '', trigger: 'blur' }
        ]
      },
      isDisable: false,
      typeList: [],
      cityList: [],
      areaList: [],
      cityAreaList: [],
      loading: true
    }
  },
  mounted () {
    const vm = this
    Promise.all([
      vm.getTypes(),
      vm.getCityAreaList()
    ]).then(() => {
      if (vm.$route.query.supplierId) {
        vm.GetSupplierData()
      } else {
        vm.loading = false
      }
    }).catch(() => {})
  },
  methods: {
    getTypes () {
      return new Promise((resolve, reject) => {
        apiAsset.Supplier.GetSupplierTypes()
          .then(res => {
            this.typeList = res.data.map(item => {
              return {
                label: item.name,
                value: item.id
              }
            })
            resolve()
          })
          .catch(err => {
            console.log(err)
            reject(new Error('取得廠商類別失敗'))
          })
      })
    },
    getCityAreaList () {
      return new Promise((resolve, reject) => {
        apiAsset.Supplier.GetCityAreas()
          .then(res => {
            this.cityAreaList = res.data
            this.cityList = this.cityAreaList.map(item => {
              return {
                label: item.CityName,
                value: item.CityName
              }
            })
            resolve()
          })
          .catch(err => {
            console.log(err)
            reject(new Error('取得城市區域失敗'))
          })
      })
    },
    setAreaList (value) {
      this.newsData.Area = ''
      const city = this.cityAreaList.find(item => item.CityName === value)
      this.areaList = city.Areas.map(item => {
        return {
          label: item,
          value: item
        }
      })
    },
    // 取得廠商詳情
    GetSupplierData () {
      if (!this.$route.query.supplierId) return
      apiAsset.Supplier.GetSupplier({
        SupplierId: this.$route.query.supplierId
      }).then(res => {
        console.log(res)
        const files = res.data.Files.map(item => {
          return {
            type: 'file',
            file: '',
            id: item.Id,
            uploadUrl: item.Url
          }
        })
        this.newsData = {
          Name: res.data.SupplierName,
          SubTitle: res.data.SubTitle,
          Type: res.data.TypeId,
          UniformNum: res.data.TaxIdNumber,
          ContactName: res.data.ContactName,
          Phone: res.data.SupplierTel,
          Cellphone: res.data.SupplierPhone,
          City: res.data.City,
          Area: res.data.Area,
          Address: res.data.Address,
          Content: res.data.Content,
          Files: files
        }
        this.originAttachments = JSON.parse(JSON.stringify(files))
        this.loading = false
      }).catch(err => {
        console.log(err)
      })
    },
    // 檔案的components回釣函式
    FilesChange (val) {
      this.newsData.Files = val
    },
    // 送出按鈕
    SubNewsData () {
      this.isDisable = true
      this.$refs.newsData.validate((valid) => {
        if (valid) {
          this.DeleteChangedFiles()
          this.FileUpload()
        } else {
          window.scrollTo(0, 0)
        }
      })
      setTimeout(() => {
        this.isDisable = false
      }, 1000)
    },
    // 上傳檔案&紀錄
    FileUpload () {
      const vobj = this
      const totalCount = vobj.newsData.Files.length
      const uploadStatus = { success: 0, error: 0 }
      const loadingWrap = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      if (totalCount === 0) {
        document.querySelector('.el-loading-text').innerHTML = '正在寫入資料中請稍後'
      } else {
        document.querySelector('.el-loading-text').innerHTML = `檔案已上傳${uploadStatus.success + uploadStatus.error}筆，共${totalCount}筆`
      }

      upload_file()
      // 上傳檔案
      function upload_file () {
        if (vobj.newsData.Files.length !== 0) {
          document.querySelector('.el-loading-text').innerHTML = `檔案已上傳${uploadStatus.success + uploadStatus.error}筆，共${totalCount}筆`
          const now_index = uploadStatus.success + uploadStatus.error

          if (vobj.newsData.Files[now_index].file === '') {
            uploadStatus.success += 1
            next()
          } else {
            SandUpdateFileApi(vobj.newsData.Files[now_index].file, res => {
              if (res !== 'error') {
                uploadStatus.success += 1
                next()
              }
            })
          }

          function next () {
            document.querySelector('.el-loading-text').innerHTML = `檔案已上傳${uploadStatus.success + uploadStatus.error}筆，共${totalCount}筆`
            if (totalCount === uploadStatus.success + uploadStatus.error) {
              document.querySelector('.el-loading-text').innerHTML = '正在寫入資料中請稍後...'
              sand_api()
            } else {
              upload_file()
            }
          }
        } else {
          sand_api()
        }
      }
      // 新增、編輯廠商
      function sand_api () {
        const { Type, UniformNum, Phone, Cellphone, Files, ...queries } = vobj.newsData
        if (!vobj.$route.query.supplierId) {
          const params = new FormData()
          Object.keys(queries).forEach(item => {
            params.append(item, queries[item])
          })
          params.append('TypeId', Type)
          params.append('TaxIdNumber', UniformNum)
          params.append('Tel', Phone)
          params.append('Phone', Cellphone)
          Files.map(item => {
            params.append('Files', item.file)
          })
          apiAsset.Supplier.PostSupplier(params)
            .then(res => {
              console.log(res)
              loadingWrap.close()
              vobj.$alert('廠商新增成功。', '', {
                confirmButtonText: '確定',
                callback: () => {
                  vobj.$router.push({ name: 'supplierList' })
                }
              })
            })
            .catch(err => {
              console.log('err', err)
              loadingWrap.close()
              vobj.$alert('廠商新增失敗', '', {
                confirmButtonText: '確定',
                callback: action => {}
              })
            })
        } else {
          const params = {
            ...queries,
            TypeId: Type,
            TaxIdNumber: UniformNum,
            Tel: Phone,
            Phone: Cellphone,
            SupplierId: vobj.$route.query.supplierId
          }
          apiAsset.Supplier.PutSupplier(params)
            .then(res => {
              console.log(res)
              loadingWrap.close()
              vobj.$alert('廠商更新成功。', '', {
                confirmButtonText: '確定',
                callback: () => {
                  vobj.$router.push({ name: 'supplierList' })
                }
              })
            })
            .catch(err => {
              console.log('err', err)
              loadingWrap.close()
              vobj.$alert('廠商更新失敗', '', {
                confirmButtonText: '確定',
                callback: action => {}
              })
            })
        }
      }
      // 處理檔案上傳API
      function SandUpdateFileApi (FileData, callback) {
        if (!vobj.$route.query.supplierId) {
          callback()
        } else {
          const uploadFormData = new FormData()
          uploadFormData.append('File', FileData)
          const params = {
            SupplierId: vobj.$route.query.supplierId,
            FormData: uploadFormData
          }
          apiAsset.Supplier.PostFiles(params)
            .then(res => {
              console.log(res)
              callback(res)
            })
            .catch(err => {
              loadingWrap.close()
              vobj.$message({
                message: '上傳過程發生異常，請重新再[送出]一次',
                type: 'warning'
              })
              console.log(err)
              callback('error')
            })
        }
      }
    },
    // 刪除有異動的檔案
    DeleteChangedFiles () {
      const vobj = this
      if (!vobj.$route.query.supplierId) return
      const uploadFileIds = vobj.newsData.Files.map(item => item.id)
      vobj.originAttachments.forEach(item => {
        const index = uploadFileIds.indexOf(item.id)
        if (index === -1) {
          vobj.deleteAttachments.push(item.id)
        } else if (vobj.newsData.Files[index].file) {
          vobj.deleteAttachments.push(item.id)
        }
      })
      if (!vobj.deleteAttachments.length) return

      const FileIds = new FormData()
      vobj.deleteAttachments.forEach(item => {
        FileIds.append('FileIds', item)
      })
      const params = {
        SupplierId: vobj.$route.query.supplierId,
        FormData: FileIds
      }
      apiAsset.Supplier.DeleteFiles(params)
        .then(res => {
          console.log(res)
        })
        .catch(err => {
          console.log(err)
        })
    },
    filterContactInput (e) {
      const reg = /[^\u4e00-\u9fa5_a-zA-Z0-9]/g // 限中英數
      if (reg.test(e)) {
        this.newsData.ContactName = this.newsData.ContactName.replace(reg, '')
      }
    },
    filterUniformNumInput (e) {
      const reg = /[^0-9]/g // 限數字
      if (reg.test(e)) {
        this.newsData.UniformNum = this.newsData.UniformNum.replace(reg, '')
      }
    }
  }
}
</script>
<style lang="sass" scoped>
#supplierEdit
  padding: 50px 0
  ::v-deep .el-dialog
    +basicDialog
    p
      line-height: 25px
  .main
    min-width: 1140px
    max-width: 1140px
    margin: 0 auto
    padding: 30px
    color: $mainFontColor
    background-color: #fff
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1)
    border-radius: $pageBorderRadius
    box-sizing: border-box
    .title_bar
      display: flex
      justify-content: space-between
      align-items: center
      .title
        font-weight: bold
        font-size: map-get($fontSize,xx-large)
        color: $mainFontColor
        text-align: left
      .tips
        color: #f00
      .tip
        font-size: map-get($fontSize,small)
        color: $subFontColor
  ::v-deep .el-form.list
    +basicFormInsert
    .el-form-item
      &.Interval
        width: 50%
        padding: 5px
      &.half
        width: 50%
      &__content
        flex: 1
        // max-width: 400px
        .file-wrap
          flex-wrap: wrap
        .el-select,.el-date-editor
          width: 100%
        .flex-wrap
          display: flex
          align-items: center
          .limit-note
            margin-left: 10px
            word-break: keep-all
            color: $grayFontColor
        .content-limit
          text-align: right
          color: $grayFontColor
    .phone-wrap
      width: 100%
  .blockWrap
    text-align: left
    display: inline-flex
    flex-wrap: wrap
    width: 100%
    margin-bottom: 30px
    padding: 0 240px 0 240px
    box-sizing: border-box
  .bottomControl
    text-align: center
    border-top: solid 1px $borderDark1
    padding: 30px 0 0
</style>
